// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1wn7f","errorLogs":"EditorFooter_errorLogs__2-_Yl"};